import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useCallAdherenceTimelineQuery } from '../../../../queries/CallAdherence/useCallAdherenceTimelineQuery';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { TransparentButton } from '../../TransparentButton';
import { styleSheet } from '../styles';
import { AdherenceTimelineRow } from './AdherenceTimelineRow';
import { CoachingAdherenceScorecard } from './CoachingAdherenceScorecard';

interface IProps {
	phoneCall: Api.IPhoneCall;
	onBack: () => void;
}

export const AdherenceTranscript: React.FC<IProps> = ({ phoneCall, onBack }) => {
	const { data, isLoading, error } = useCallAdherenceTimelineQuery({
		phoneCallId: phoneCall.id,
		enabled: true,
	});

	const hasAiRow = data?.some(r => r._type === 'AIChatMessageTimelineItem') ?? false;

	return (
		<div className={css(styleSheet.transcriptionContent)}>
			{isLoading && (
				<div
					role='status'
					aria-label='Loading AI coaching activity'
					className={css(styleSheet.transcriptionContentFooter)}
				>
					<LoadingSpinner type='small' />
				</div>
			)}
			{!isLoading && error && (
				<p className={css(styleSheet.transcriptionContentLine)}>
					Couldn't load AI coaching activity. Please try again.
				</p>
			)}
			{!isLoading && !error && !hasAiRow && (
				<p className={css(styleSheet.transcriptionContentLine)}>No AI coaching activity for this call.</p>
			)}
			{!isLoading &&
				!error &&
				hasAiRow &&
				data?.map((row, i) => (
					<AdherenceTimelineRow
						key={row._type === 'AIChatMessageTimelineItem' ? row.id : `s-${i}-${row.startTimeOffset}`}
						row={row}
					/>
				))}
			{!isLoading && !error && <CoachingAdherenceScorecard phoneCall={phoneCall} />}
			<div className={css(styleSheet.transcriptionContentFooter)}>
				<TransparentButton className={css(styleSheet.regularButton)} onClick={onBack}>
					← Back to transcript
				</TransparentButton>
			</div>
		</div>
	);
};
